import {notify} from '@gemcook/notification';
import {delay} from 'blend-promise-utils';

import resources from '@resources';
import api from '@api';
import constants from '@constants';
import utils from '@utils';

export const downloadCsv = async (
  teamId: MeStore['teamId'],
  setIsExporting: React.Dispatch<React.SetStateAction<boolean>>
) => {
  setIsExporting(true);
  try {
    const res = await api.csv.exportUsers({teamId});
    // Excelでも見れるように
    const bom = new Uint8Array([0xef, 0xbb, 0xbf]);
    // APIから取得したCSVをダウンロードするurlを作成
    const url = URL.createObjectURL(new Blob([bom, res.data]));
    // aタグを擬似的に作成
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', 'ユーザー一覧.csv');
    document.body.appendChild(link);
    link.click();
  } catch (error) {
    notify(constants.ERRORS.UNKNWON, 'error');
  } finally {
    setIsExporting(false);
  }
};

export const downloadSampleCsv = (
  setIsDownloading: React.Dispatch<React.SetStateAction<boolean>>
) => {
  setIsDownloading(true);
  // aタグを擬似的に作成
  const link = document.createElement('a');

  link.href = constants.CSV.sample;

  link.click();
  setIsDownloading(false);
};

/** CSVファイルアップロード */
export const upload = async (
  event: any,
  me: MeStore,
  setIsErrorModal: React.Dispatch<React.SetStateAction<boolean>>,
  setErrorMessages: React.Dispatch<React.SetStateAction<string>>,
  setIsShowLink: React.Dispatch<React.SetStateAction<boolean>>,
  setIsLoading: React.Dispatch<React.SetStateAction<boolean>>,
  actions: MeAction
) => {
  const element: HTMLInputElement = <HTMLInputElement>(
    document.getElementById('csv')
  );

  setIsLoading(true);

  // ファイルの情報を取得
  const file = event.target.files[0];

  // CSV以外のファイルが選択されているときはエラーを出す
  if (
    file &&
    file.type &&
    file.type !== 'application/vnd.ms-excel' &&
    file.type !== 'text/csv'
  ) {
    notify('CSV以外のファイルが選択されています。', 'error');
    setIsLoading(false);
  }

  // インポートされたCSVのBlobを作成
  const blob = new Blob([file]);
  const reader = new FileReader();
  reader.readAsDataURL(blob);
  // ファイル読み込み処理を待つ
  await delay(100);
  const fileCode = String(reader.result);
  // base64のみ取り出す
  const base64 = fileCode.split(',').pop();

  try {
    await api.csv.importUsers({
      userId: me.id,
      teamId: me.teamId,
      file: base64,
    });

    await utils.stripe.updateUsage(me);
    actions.me.updateMe();
    notify('CSVインポートに成功しました', 'success');
  } catch (error) {
    if (error.response.data.message) {
      // モーダルの中に表示するメッセージを作成
      let errorMessage = '';
      let line;
      let message;

      // APIサーバーからのエラーメッセージを表示する場合

      switch (error.response.data.message) {
        case 'team capacity is 1000 max':
          setIsShowLink(true);
          break;
        case 'phoneNumber is not unique in the CSV':
          errorMessage = `${error.response.data.line}行目の携帯番号がCSV内で重複しています。`;
          break;
        case 'email is not unique in the CSV':
          errorMessage = `${error.response.data.line}行目のメールアドレスがCSV内で重複しています。`;
          break;
        case 'validation error':
          errorMessage = `${error.response.data.line}行目の書式が正しくありません。`;
          break;
        case 'CSV format error':
          errorMessage =
            'CSVのフォーマットに間違いがあります。サンプルCSVを使用してユーザーインポートを行ってください。';
          break;
        case 'phoneNumber is not unique':
          errorMessage = `${error.response.data.line}行目の携帯番号は既に登録済みです`;
          break;
        case 'adminuser could not be downgrade':
          errorMessage = `${error.response.data.line}行目のユーザーは特権管理者権限から変更できません。`;
          break;
        case 'email is not unique':
          errorMessage = `${error.response.data.line}行目のメールアドレスは既に登録済みです`;
          break;
        case 'An account with the given email already exists.':
          errorMessage = `${error.response.data.line}行目のメールアドレスは既に特権管理者もしくは管理者として登録済みです`;
          break;
        case 'user is not authorized to this action':
          errorMessage = `${error.response.data.line}行目の編集は特権管理者のみが実行できます。CSVから管理者の情報を削除して再度インポートを行ってください。`;
          break;
        case 'adminuser could not be registered':
          errorMessage = `特権管理者権限のユーザーは追加できません。${error.response.data.line}行目を確認してください。`;
          break;
        case 'unknown error':
          errorMessage = constants.ERRORS.UNKNWON;
          break;
      }

      // Cognitoのエラーメッセージを表示する場合
      if (
        error.response.data.message &&
        error.response.data.error &&
        !errorMessage
      ) {
        line = error.response.data.line
          ? `${error.response.data.line}行目`
          : '';

        message = error.response.data.error['Message_']
          ? `${resources.csv.getErrorMessage(
              error.response.data.error['Message_']
            )}`
          : '';

        errorMessage = line + message;
      }

      setErrorMessages(errorMessage);
      setIsErrorModal(true);
    } else {
      setErrorMessages(constants.ERRORS.UNKNWON);
      setIsErrorModal(true);
    }
  } finally {
    // 選択したCSVファイルを削除する
    setIsLoading(false);
    element.value = '';
  }
};
